export default __webpack_public_path__ + "static/media/the-solar-exchange-bg.37b95d9c.jpeg";